const ReactAppStage = process.env.REACT_APP_API_STAGE;
console.log("abc ",ReactAppStage)
const dev = {
  API_ENDPOINT_URL:
    ReactAppStage == "Dev"
      ? "https://hrmsapi.riolabz.com/v1"
      : "https://riocrmapi.riolabz.com/v1",
};

const prod = {
  API_ENDPOINT_URL:
    ReactAppStage == "Dev"
      ? "https://hrmsapi.riolabz.com/v1"
      : "https://riocrmapi.riolabz.com/v1",
};

const test = {
  API_ENDPOINT_URL:
    ReactAppStage == "Dev"
      ? "https://hrmsapi.riolabz.com/v1"
      : "https://riocrmapi.riolabz.com/v1",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
